const STORAGE_KEY = "POST_LOGIN_PATH";

// Only internal paths from this list are ever stored or followed.
const ALLOWED_PATHS = ["/integrations/hibob/install"];

const isAllowed = (path) => ALLOWED_PATHS.includes(path);

export const rememberPostLoginPath = (pathname) => {
	if (!isAllowed(pathname)) {
		return;
	}
	try {
		sessionStorage.setItem(STORAGE_KEY, pathname);
	} catch (err) {}
};

export const peekPostLoginPath = () => {
	try {
		const path = sessionStorage.getItem(STORAGE_KEY);
		return isAllowed(path) ? path : null;
	} catch (err) {
		return null;
	}
};

export const clearPostLoginPath = () => {
	try {
		sessionStorage.removeItem(STORAGE_KEY);
	} catch (err) {}
};

export const consumePostLoginPath = () => {
	const path = peekPostLoginPath();
	clearPostLoginPath();
	return path;
};
